import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export const useResetOnBack = (isFiltered, resetFilters) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasPushedRef = useRef(false);

  useEffect(() => {
    if (isFiltered && !hasPushedRef.current) {
      setSearchParams({ filtered: "1" });
      hasPushedRef.current = true;
    }
  }, [isFiltered]);

  useEffect(() => {
    const stillFiltered = searchParams.get("filtered") === "1";
    if (!stillFiltered && hasPushedRef.current) {
      hasPushedRef.current = false;
      resetFilters();
    }
  }, [searchParams]);
};